import { render, staticRenderFns } from "./BatchReport.vue?vue&type=template&id=128f2d4a&scoped=true&"
import script from "./BatchReport.vue?vue&type=script&lang=js&"
export * from "./BatchReport.vue?vue&type=script&lang=js&"
import style0 from "./BatchReport.vue?vue&type=style&index=0&id=128f2d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f2d4a",
  null
  
)

export default component.exports